var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"fixed inset-0 bg-brand-lightGray/75 flex justify-center items-center z-50",attrs:{"data-automation":"loader"}},[_c('LoaderIcon',{staticClass:"animate-spin",attrs:{"data-automation":"loader-icon"}}),_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }